import { usePatronSelector } from './use-patron-selector';

export function useProgram() {
  const program = usePatronSelector((state) => state.program);
  return program;
}
